<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';
import BoConfig from '@config/BoConfig.js';
import env from '../env';

export default {
  extends: Base,
  data(){
    return {
      Name:"ViewEmployeeData",
      PageName: "View Employee Data",
      ObjectName: "View Employee Data",
      NoList: true,
      detail: {},
      input: {},
      mrValidation:{},
      selectType: [
        {mws_id: 1, mws_name: "Employee"},
        {mws_id: 2, mws_name: "Outsource"}
      ]
    }
  },
  computed:{
    downloadExcelUrl(){ 
    let fullPath = this.$route.fullPath.replace('/view-employee-data?','')
    return env.baseUrl+"/api/"+this.Name+"?downloadExcel=true"+"&"+fullPath+
    "&token="+Gen.getCookie("botk") 
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)
    this.refreshData()
  },
  methods:{
  },
  watch:{
    '$route.query'(v){
      this.refreshData()
    },
    'filter.startdate'(v){
      if(this.filter.enddate) this.search()
      if(global.moment(this.filter.startdate,'DD-MM-YYYY').isAfter(global.moment(this.filter.enddate,'DD-MM-YYYY')) || !this.filter.enddate) this.$set(this.filter, 'enddate', this.filter.startdate)
    },
    'filter.enddate'(v,b){
      if(global.moment(this.filter.startdate,'DD-MM-YYYY').isAfter(global.moment(this.filter.enddate,'DD-MM-YYYY')) || !this.filter.startdate) this.$set(this.filter, 'startdate', this.filter.enddate)
      if(b) this.search()
    },
    'filter.workstatus'(v){
      if(!this.filter.workstatus){
        let query = Object.assign({}, this.$route.query);
        delete query.workstatus;
        this.$router.replace({ query });
      } else {
        this.search()
      }
    },
    'filter.department'(v){
      if(!this.filter.department){
        let query = Object.assign({}, this.$route.query);
        delete query.department;
        this.$router.replace({ query });
      } else {
        this.search()
      }
    },
    'filter.costcenter'(v){
      if(!this.filter.costcenter){
        let query = Object.assign({}, this.$route.query);
        delete query.costcenter;
        this.$router.replace({ query });
      } else {
        this.search()
      }
    },
    'filter.division'(v){
      if(!this.filter.division){
        let query = Object.assign({}, this.$route.query);
        delete query.division;
        this.$router.replace({ query });
      } else {
        this.search()
      }
    }
  }
}
</script>

<template>
  <div class="container-fluid">
    <PageTitle></PageTitle>
    
    <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
    <div class="card" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-3">
              <Select2 url="/department-select" :object="['msg_name','msg_name']" v-model="filter.department">
                <option value="">-- All Department --</option>
              </Select2>
            </div>
            <div class="col-sm-3">
              <Select2 url="/costcenter-select" :object="['costcenter','mcc_costcenter']" v-model="filter.costcenter">
                <option value="">-- All Cost Center --</option>
              </Select2>
            </div>
            <div class="col-sm-3">
              <Select2 name="workstatus" :options="selectType" :object="['mws_name','mws_name']" v-model="filter.workstatus">
                <option value="">-- Employee Type --</option>
              </Select2>
            </div>
          </div>
          
          <div class="row mt10">
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-2">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-bordered nowrap">
          <thead>
            <tr>
              <th><SortField name="employeeno" label="Employee No"></SortField></th>
              <th><SortField name="cwid" label="CWID"></SortField></th>
              <th><SortField name="ipin" label="IPIN"></SortField></th>
              <th><SortField name="employeename" label="Employee Name"></SortField></th>
              <th><SortField name="department" label="Department"></SortField></th>
              <th><SortField name="poitiontitle" label="Position Title"></SortField></th>
              <th><SortField name="costcenter" label="Cost Center"></SortField></th>
              <th><SortField name="workstatus" label="Work Status"></SortField></th>
              <th><SortField name="employee_status" label="Status"></SortField></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{v.employeeno}}</td>
              <td>{{v.cwid||"-"}}</td>
              <td>{{v.ipin||"-"}}</td>
              <td>{{v.employeename||"-"}}</td>
              <td>{{v.department||"-"}}</td>
              <td>{{v.jobtitle||"-"}}</td>
              <td>{{v.costcenter||"-"}}</td>
              <td>{{v.workstatus||"-"}}</td>
              <td>{{v.employee_status?"Active":"Inactive"}}</td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-left">
          <a :href="downloadExcelUrl" v-if="data.total" target="_blank" class="btn btn-success waves-effect waves-light"><i class="icon-cloud-download"></i> Export Excel</a>
        </div>
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>
